import styled from 'styled-components';

const TotalRow = (props) => {
    return (
    <TotalRowStatus>Rows: {props.count}</TotalRowStatus>
    );
  };
  
  export default TotalRow;

  const TotalRowStatus = styled.div`
  width: 100%;
  padding: 6px;
  border-bottom: 1px solid #BEC3C7;
  border-left: 1px solid #BEC3C7;
  border-right: 1px solid #BEC3C7;
`